import React from "react";
import moment from "moment";

const handleValidDate = (date) => {
  if (!date || date === "Invalid date") {
    return "Invalid date";
  }
  try {
    const dateObj = new Date(date);
    if (isNaN(dateObj.getTime())) {
      return "Invalid date";
    }
    return moment(dateObj).format("DD MMM Y");
  } catch (error) {
    return "Invalid date";
  }
};

const handleValidTime = (time) => {
  if (!time || time === "Invalid date") {
    return "Invalid date";
  }
  try {
    const time1 = new Date(time);
    if (isNaN(time1.getTime())) {
      return "Invalid date";
    }
    const getHour = time1.getUTCHours();
    const getMin = time1.getUTCMinutes();
    const getTime = `${getHour}:${getMin}`;
    var meridiem = "";
    if (getHour >= 12) {
      meridiem = "PM";
    } else {
      meridiem = "AM";
    }
    const updateTime = moment(getTime, 'hh:mm').format('hh:mm') + " " + meridiem;
    return updateTime;
  } catch (error) {
    return "Invalid date";
  }
};

const Rating = (cell) => {
  return (
    <React.Fragment>
      <span>
        <span className="badge bg-light text-body fs-12 fw-medium">
          <i className="mdi mdi-star text-warning me-1"></i>{cell.getValue()}
        </span>
      </span>
    </React.Fragment>
  );
};

const Published = (cell) => {
  const dateValue = cell.getValue();
  if (!dateValue || dateValue === "Invalid date" || isNaN(new Date(dateValue).getTime())) {
    return (
      <React.Fragment>
        <span className="text-muted">-</span>
      </React.Fragment>
    );
  }
  return (
    <React.Fragment>
      <span>
        {handleValidDate(dateValue)}
        <small className="text-muted ms-1">{handleValidTime(dateValue)}</small>
      </span>
    </React.Fragment>
  );
};

const Price = (cell) => {
  const priceValue = cell.getValue();
  if (priceValue === undefined || priceValue === null || priceValue === "") {
    return (
      <React.Fragment>
        <span className="text-muted">-</span>
      </React.Fragment>
    );
  }
  // Format price with 2 decimal places
  const formattedPrice = typeof priceValue === "number" 
    ? priceValue.toFixed(2) 
    : parseFloat(priceValue || 0).toFixed(2);
  return (
    <React.Fragment>
      {"£ " + formattedPrice}
    </React.Fragment>
  );
};

export { Rating, Published, Price };
